// Centralized configuration & safe backend URL resolution
// Rule: if REACT_APP_BACKEND_URL exists, use it; otherwise, build from current context (same host) with default port 8000.

let cachedBackend = null;

// Export for direct access to the environment variable (CRA requires literal access)
const rawBackendEnv = process.env.REACT_APP_BACKEND_URL; // inlined at build time by CRA
const DEFAULT_PORT = `8000`;
// Single source of truth for backend root resolution
// Priority:
// 1) REACT_APP_BACKEND_URL (build-time)
// 2) window.__FASTPLANET_BACKEND_URL (runtime override)
// 3) Current context (same protocol + hostname), default port 8000
export const BACKEND_ROOT = (() => {

  let candidate = rawBackendEnv;
    // Optional runtime override
    if (!candidate && typeof window !== 'undefined' && window.__FASTPLANET_BACKEND_URL) {
      candidate = window.__FASTPLANET_BACKEND_URL;

  }
    // Fallback: same host with default backend port 8000
    if (!candidate && typeof window !== 'undefined' && window.location) {
      const { protocol, hostname } = window.location;
      candidate = `${protocol}//${hostname}:${DEFAULT_PORT}`;
  }

  return String(candidate).trim().replace(/\/$/, '');
})();
// http://localhost:8000

export function getBackendBase() {
  if (cachedBackend) return cachedBackend;
  cachedBackend = BACKEND_ROOT;
  return cachedBackend;
}

// Resolve at import time, but remains adjustable via env/global before bundle loads
export const API_BASE = getBackendBase();
export const API_ROOT = `${API_BASE}/api`;

// Resolve API URLs coming from backend (e.g., "/api/photos/{id}/raw") to absolute URLs
export function resolveApiUrl(pathOrUrl) {
  if (!pathOrUrl) return pathOrUrl;
  const s = String(pathOrUrl);
  if (/^https?:\/\//i.test(s)) return s; // already absolute
  if (s.startsWith('/')) return `${API_BASE}${s}`; // absolute path on backend host
  // Treat as relative API path
  return `${API_ROOT}/${s.replace(/^\/+/, '')}`;
}
